module.exports = __webpack_public_path__ + "img/nitja-mainlogo-500px.447c790d.svg";